// Food Vendor Watcher Actions
export const GET_DASHBOARD_WATCHER = "GET_DASHBOARD_WATCHER"

//..............................................................................................................................................//

// Food Vendor Reducer Actions
export const DASHBOARD_LIST = "DASHBOARD_LIST"